import { EXLY_BACKEND_API_HOST } from "repoV2/constants/apis";

export const checkout_pages_api = {
    checkout_page_details: `${EXLY_BACKEND_API_HOST}/host/checkout/page/details`,
    get_loyalty_list: `${EXLY_BACKEND_API_HOST}/payments/exly/discounts/loyalty`,
};
